import type { Action } from '@0xtorch/core'

/** action.transfers の中に asset symbol が `@ + 数字` or `数字` のものがあった場合、 evidence = 'none' で上書きする */
export const parseHyperliquidActionEvidence = (action: Action): Action => {
  if (
    action.transfers.some(
      (transfer) =>
        transfer.asset.type === 'CryptoCurrency' &&
        /^\@?[\d]+$/.test(transfer.asset.symbol),
    )
  ) {
    return {
      ...action,
      evidence: 'none',
    }
  }
  return action
}
